@import 'styles/variables';

.menu {
  min-width: 250px;
}

.integrationItemContainer {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.integrationItem {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 5px 0;
}

.integrationDetails {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
}

.avatarWithStatus {
  display: flex;
  align-items: center;
  position: relative;
}

.alertOverlay {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.errorOverlay {
  background: var(--red-50);

  [data-autopilot-system-redesign='on'] & {
    background: var(--red-90);
  }
}

.reauthOverlay {
  background: var(--red-50);

  [data-autopilot-system-redesign='on'] & {
    background: var(--red-50);
    padding-bottom: 1px;
  }
}

.warningOverlay {
  background: var(--yellow-50);
}

.successOverlay {
  background: var(--green-50);
}

.addNewAccountItem {
  display: flex;
  align-items: center;
  padding: 4px 0;
  gap: 12px;
}

.addNewAccountTrigger {
  background: none;
  border: 0;
  text-align: left;
  cursor: pointer;
  width: 100%;
  border-radius: 6px;
  transition: background-color 120ms ease;

  &:hover {
    background-color: var(--dark-5);
  }
}

.postedList {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 230px;
  padding: 4px;
}

.postedRow {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px 4px;
}

.postedRowHeader {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
}

.postedRowDetails {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.postedRowName {
  color: var(--dark-90);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.postedRowHandle {
  color: var(--dark-40);
}

.postedActionButton {
  width: 100%;
}

.postedRetry {
  color: var(--red-50);
}

.postingLabel {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: var(--dark-60);
  padding: 8px;
}

.postedSeparator {
  height: 1px;
  background: var(--dark-4);
  margin: 4px 0;
}
